'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { paths } from '@/lib/config/paths.config';

export function HeaderAuthContainer() {
  return (
    <div className="flex items-center bg-black hover:bg-black/80">
      <Link
        href={paths.auth.signUp}
        className="flex items-center p-4 font-medium text-accent text-md"
      >
        <ArrowRight size={20} className="mr-2" /> Teste Gratuitamente
      </Link>
    </div>
  );
}
